import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Alert from "components/alert-view";
import { defineMessages, FormattedMessage } from "react-intl";
import appconfig from "config/appconfig";
import { Typography } from "@getgo/chameleon-web-react-wrapper";
import { PasskeyOutlinedIcon } from "@getgo/chameleon-icons/react";
import classes from "./alert.scss";
import useAnalyticsHelpers from "lib/analytics-helpers";

const t = defineMessages({
  "alert.passkey-signin.description": {
    id: "alert.passkey-signin.description",
    defaultMessage: "Use a passkey to access GoTo in a more convenient and secure way.",
  },
  "common.learn-more": {
    id: "common.learn-more",
    defaultMessage: "Learn more",
    description: "Link text for any anchor tag",
  },
});

export const AlertPasskeyView = ({ handleDismiss, showPasskeyBanner }) => {
  const { track } = useAnalyticsHelpers();

  useEffect(() => {
    if (showPasskeyBanner) {
      track('Alert Shown', {
        alertType: 'passkey_info',
        alertMessage: 'Use a passkey to access GoTo',
      });
    }
  }, [showPasskeyBanner, track]);

  const handleLearnMoreClick = () => {
    track('Alert Link Clicked', {
      alertType: 'passkey_info',
      linkText: 'Learn more',
      linkUrl: 'https://support.goto.com/connect/help/create-and-manage-passkeys-for-sign-in',
    });
  };

  const handleDismissClick = () => {
    track('Alert Dismissed', {
      alertType: 'passkey_info',
    });
    handleDismiss();
  };

  return (
    <React.Fragment>
      {showPasskeyBanner && (<Alert
        type={appconfig.alertTypes.WARNING}
        closable
        icon={<PasskeyOutlinedIcon />}
        body={
          <span className={classes.bannerMessageText}>
            <Typography color="brand-color-black">
              <FormattedMessage
                {...t["alert.passkey-signin.description"]} />
              <a
                className="learnMoreLink"
                href="https://support.goto.com/connect/help/create-and-manage-passkeys-for-sign-in"
                rel="noopener noreferrer"
                target="_blank"
                onClick={handleLearnMoreClick}
              >
                <FormattedMessage {...t["common.learn-more"]}/>
              </a>
            </Typography>
          </span>
        }
        handleDismiss={handleDismissClick}
      />)}
    </React.Fragment>
  );
};

AlertPasskeyView.propTypes = {
  alertVisisble: PropTypes.bool.isRequired,
  handleDismiss: PropTypes.func.isRequired,
  showPasskeyBanner: PropTypes.bool.isRequired
};

export default AlertPasskeyView;
